<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <span class=" mr-auto">
    <button
      mat-raised-button
      routerLink="../.."
      class="m-1 mr-2"
      id="back"
    >
      <mat-icon>arrow_back</mat-icon> Back
    </button>

    <button
      mat-raised-button
      routerLink="/items/{{ item.id }}/edit"
      id="edit"
      *ngIf="item?.id"
      class="m-1 mr-2">
      <mat-icon>edit</mat-icon> Edit
    </button>
  </span>
</nav>

<div class="container-fluid p-3">
  <div class="row">
    <div class="col-12 col-lg-6">
      <h6>Name</h6>
      <p id="name">{{ item.name }}</p>

      <h6>Question</h6>
      <p>{{item.question}}</p>

      <h6>Tooltip</h6>
      <p>{{item.tooltip}}</p>
    </div>
  </div>
</div>
